// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3RqsP","actionsCol":"EnrolledClinics_actionsCol__28yQ4"};